import { useEffect, useRef } from "react";

export const Cursor = () => {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    let rx = 0, ry = 0, dx = 0, dy = 0, raf;

    const move = (e) => {
      dx = e.clientX;
      dy = e.clientY;
      if (dot.current) {
        dot.current.style.transform = `translate(${dx - 3.5}px, ${dy - 3.5}px)`;
      }
    };
    const loop = () => {
      rx += (dx - rx) * 0.15;
      ry += (dy - ry) * 0.15;
      if (ring.current) {
        ring.current.style.transform = `translate(${rx - 19}px, ${ry - 19}px)`;
      }
      raf = requestAnimationFrame(loop);
    };

    const over = (e) => {
      if (e.target.closest("a,button,[data-cursor]")) {
        ring.current?.style.setProperty("width", "62px");
        ring.current?.style.setProperty("height", "62px");
        ring.current?.style.setProperty("transform-origin", "center");
      }
    };
    const out = (e) => {
      if (e.target.closest("a,button,[data-cursor]")) {
        ring.current?.style.setProperty("width", "38px");
        ring.current?.style.setProperty("height", "38px");
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    window.addEventListener("mouseout", out);
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      window.removeEventListener("mouseout", out);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div ref={dot} className="cursor-dot hidden md:block" />
      <div
        ref={ring}
        className="cursor-ring hidden md:block"
        style={{ transition: "width 0.25s ease, height 0.25s ease" }}
      />
    </>
  );
};
